import type { ReactNode } from 'react';
import { Redirect } from 'wouter';
import { useAuth } from '@/contexts/auth-context';
import { useIsTherapyPractice } from '@/hooks/use-sessions';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Sloty Sessions pages exist only for providers in a psychotherapy practice;
 * everyone else is sent back to their dashboard. The API enforces the same
 * rule, this just avoids showing a page that would only return 403s.
 */
export function TherapyPracticeGuard({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const { enabled, isLoading } = useIsTherapyPractice();

  if (isLoading) return <Skeleton className="h-64 w-full" />;
  if (!enabled) return <Redirect to={user?.role === 'staff' ? '/staff/dashboard' : '/admin/dashboard'} replace />;
  return <>{children}</>;
}
